import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { NgxEditorModule } from 'ngx-editor'
import { Editor } from 'ngx-editor'

@Component({
  selector: 'hyperkit-editor',
  standalone: true,
  imports: [FormsModule, NgxEditorModule],
  templateUrl: './editor.component.html',
  styleUrl: './editor.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class EditorComponent implements OnInit, OnDestroy, OnChanges {
  @Input() value = ''
  @Input() height: string | number = '250px'
  @Output() valueChange = new EventEmitter<string>()
  editor!: Editor
  html = ''

  /** True while the editor has keyboard focus — prevents parent
   *  echo-backs from overwriting in-progress user edits. */
  private focused = false

  ngOnInit(): void {
    this.editor = new Editor()
    this.html = this.value
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      // Always apply on first render; skip echo-backs while user is typing
      if (changes['value'].firstChange || !this.focused) {
        this.html = this.value
      }
    }
  }

  ngOnDestroy(): void {
    this.editor.destroy()
  }

  get editorHeight(): string {
    return typeof this.height === 'number' ? `${this.height}px` : this.height
  }

  onEditorChange(value: string): void {
    this.valueChange.emit(value)
  }

  onFocusIn(): void {
    this.focused = true
  }

  onFocusOut(): void {
    this.focused = false
  }
}
